import {t} from '@lingui/core/macro';
import {createAsyncThunk} from '@reduxjs/toolkit';

import {ApiUrls} from 'shared/config/model/urls';
import SimpleResponse from 'shared/api/model/SimpleResponse';
import createHttpRequest from 'shared/api/http';
import {setTokens} from 'shared/api/auth';

import NewPasswordData from '../NewPasswordData';

export const setNewPassword = createAsyncThunk<SimpleResponse, NewPasswordData>(
    'auth/setNewPassword',
    // eslint-disable-next-line camelcase
    async({userId, token, password, password_confirmation}) => {
        const tokens = await createHttpRequest({
            method: 'POST',
            path: ApiUrls.PASSWORD_RESET_CONFIRM(userId, token),
            errorMessage: t`Ошибка при установке нового пароля`,
            // eslint-disable-next-line camelcase
            data: {password, password_confirmation},
            isAnonymous: true,
        });
        setTokens(tokens.data);

        return {status: true, message: t`Новый пароль успешно установлен`};
    },
);
